import React, { Component } from 'react';


import GaugeComponent from './../components/ChartGaugeDashboard/GaugeComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class GaugeDB extends Component {
  render() {
    const { data, name, title, date } = this.props;
    return (
      <GaugeComponent
        name={name}
        title={title}
        data={data}
        date={date}
        openDialog={this.props.openDialog}
        onClickGraphic={this.props.onClickGraphic}
        seeMore={this.props.seeMore}
      />
    );
  }
}

export default GaugeDB;